export type DeviceTypeEntry = {
  os: string;
  models: Record<string, string[]>;
  versions: string[];
};

export const DEVICE_CATALOG: Record<string, DeviceTypeEntry> = {
  iPhone: {
    os: "iOS",
    models: {
      "iPhone 7 / 8": ["iPhone 7", "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus"],
      "iPhone X / XR": ["iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max"],
      "iPhone 11 Series": ["iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max"],
      "iPhone 12 Series": ["iPhone 12", "iPhone 12 Pro", "iPhone 12 Pro Max", "iPhone 12 mini"],
      "iPhone 13 Series": ["iPhone 13", "iPhone 13 Pro", "iPhone 13 Pro Max", "iPhone 13 mini"],
      "iPhone 14 Series": ["iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max"],
      "iPhone 15 Series": ["iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max"],
      "iPhone 16 Series": ["iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max"],
      "iPhone 17 Series": ["iPhone 17", "iPhone 17 Pro", "iPhone 17 Pro Max"],
    },
    versions: ["12", "13", "14", "15", "16", "17", "18", "26"],
  },
  iPad: {
    os: "iOS",
    models: {
      iPad: [
        "iPad (1st Gen)", "iPad (2nd Gen)", "iPad (3rd Gen)", "iPad (4th Gen)", "iPad (5th Gen)",
        "iPad (6th Gen)", "iPad (7th Gen)", "iPad (8th Gen)", "iPad (9th Gen)", "iPad (10th Gen)",
      ],
      "iPad Mini": [
        "iPad mini 1", "iPad mini 2", "iPad mini 3", "iPad mini 4",
        "iPad mini 5", "iPad mini 6", "iPad mini 7",
      ],
      "iPad Air": [
        "iPad Air 1", "iPad Air 2", "iPad Air 3",
        "iPad Air 4", "iPad Air 5", "iPad Air 6",
      ],
      "iPad Pro": ["iPad Pro 9.7", "iPad Pro 10.5", "iPad Pro 11", "iPad Pro 12.9"],
    },
    versions: ["13", "14", "15", "16", "17", "18", "26"],
  },
  "Android Smartphone": {
    os: "Android",
    models: {
      "Samsung Galaxy": [
        "A52s 5G", "A54 5G", "A55 5G", "S20 FE 5G", "S21", "S22",
        "S23", "S23 Ultra", "S24", "S24 Ultra", "S25 Ultra",
      ],
      "Google Pixel": [
        "Pixel 6a", "Pixel 7", "Pixel 7 Pro", "Pixel 8", "Pixel 8 Pro", "Pixel 9", "Pixel 9 Pro",
      ],
      OnePlus: ["6T", "7 Pro", "8 Pro", "9 Pro", "10 Pro", "11", "12", "13"],
      Xiaomi: ["11T Pro", "12", "13T", "13T Pro", "14", "14T", "14T Pro", "15"],
      "Huawei / Honor": ["Honor 20", "Mate 20", "Mate 30", "P20", "P30"],
      Motorola: ["Edge 30", "Edge 40", "Edge 50", "Moto G14", "Moto G54", "Moto G84"],
      "Sony Xperia": ["Xperia 1 V", "Xperia 5 V", "Xperia XZ2"],
    },
    versions: ["10", "11", "12", "13", "14", "15", "16"],
  },
  "Android Tablet": {
    os: "Android",
    models: {
      "Samsung Galaxy Tab": ["Tab A8", "Tab A9+", "Tab S6 Lite", "Tab S7", "Tab S8", "Tab S9", "Tab S9 FE"],
      "Xiaomi Pad": ["Pad 5", "Pad 6", "Pad 7 Pro"],
      "Redmi Pad": ["Redmi Pad", "Redmi Pad Pro", "Redmi Pad SE"],
      "OnePlus Pad": ["OnePlus Pad", "OnePlus Pad Go"],
    },
    versions: ["11", "12", "13", "14", "15", "16"],
  },
};
